import React, { useCallback, useEffect, useMemo }    from 'react';
import { connect }                                   from 'react-redux';
import DV                                            from 'ts-data-validator';
import { formValueSelector, reset, SubmissionError } from 'redux-form';

import NotificationForm from './NotificationForm';
import { useUser }      from '../../../../providers/user';

const Notification = (props) => {
  const {
          agreement,
          closeModal,
          dispatch,
          isFormVisible = false,
          userName,
          userPhone,
        } = props;

  const {
          appealTypes,
          getToken,
          name: {
                  first_name,
                  last_name,
                  patronymic,
                },
          phone,
          send,
          tokenList,
          userInitialStateLoaded,
        } = useUser();

  const submitNotificationForm = useCallback((event, handleSubmit, valid) => {
    event.preventDefault();

    const _token = tokenList.PHONE || null;

    handleSubmit((values) => {
      const validateValues = {
        ...values,
        phone: values.phone.replace(/\s*\*$/g, ''),
        _token,
      };

      return send(validateValues)
        .then(() => {
          dispatch(reset('NotificationForm'));
          closeModal();
        })
        .catch((errors) => {
          throw new SubmissionError(errors);
        });
    })(event);
  }, [closeModal, send, dispatch, tokenList]);

  const NotificationFormProps = useMemo(() => {
    let name = userName;

    if (!DV.isString(name)) {
      name = null;

      if (DV.isString(first_name) && DV.isString(last_name)) {
        name = `${last_name} ${first_name}`;

        if (DV.isString(patronymic)) {
          name = `${name} ${patronymic}`;
        }
      }
    }

    let props = { submitForm: submitNotificationForm };

    if (userInitialStateLoaded) {
      const appealTypeId = appealTypes.find((item) => item.aliasKey === 'PHONE')?.appealTypeId;
      const _token       = tokenList.PHONE || null;

      props.initialValues = {
        appealTypeId,
        aliasKey: 'PHONE',
        name,
        phone:    userPhone || phone,
        _token,
      };
    }

    return props;
  }, [
    agreement,
    appealTypes,
    first_name,
    last_name,
    patronymic,
    phone,
    submitNotificationForm,
    tokenList,
    userInitialStateLoaded,
    userName,
    userPhone,
  ]);

  useEffect(() => {
    if (!tokenList.hasOwnProperty('PHONE')) {
      getToken('PHONE');
    }
  }, [tokenList]);

  return (
    <>
      {isFormVisible && (<NotificationForm
        {...NotificationFormProps} closeModal={closeModal}
      />)}
    </>
  );
};

function mapStateToProps(state) {
  const form = formValueSelector('NotificationForm');

  return {
    agreement: form(state, 'agreement') || null,
    userName:  form(state, 'name') || null,
    userPhone: form(state, 'phone') || null,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Notification);
